module.exports = __webpack_public_path__ + "media/images/flags/32/Russia-dc0b739809823948bc605482f30bc4ac.png";